interface SSOAuthSyncPayload {
  type: 'login'
  authToken: string
  targetUrl: string
  timestamp: number
}

const SSO_AUTH_SYNC_CHANNEL = 'SSO_AUTH_SYNC_CHANNEL'

const getSSOAuthSyncChannelName = (targetUrl: string): string => `${SSO_AUTH_SYNC_CHANNEL}:${targetUrl}`

const getSSOAuthTokenFromMessage = (data: unknown, targetUrl: string): string => {
  const payload = data as Partial<SSOAuthSyncPayload>
  if (
    payload.type === 'login' &&
    payload.authToken &&
    payload.targetUrl === targetUrl
  ) {
    return payload.authToken
  }
  return ''
}

export const notifySSOAuthLogin = (authToken: string, targetUrl: string): void => {
  if (!authToken || !targetUrl || typeof BroadcastChannel === 'undefined') return
  const payload: SSOAuthSyncPayload = {
    type: 'login',
    authToken,
    targetUrl,
    timestamp: Date.now()
  }
  const channel = new BroadcastChannel(getSSOAuthSyncChannelName(targetUrl))
  channel.postMessage(payload)
  channel.close()
}

export const subscribeSSOAuthLogin = (targetUrl: string, handler: (authToken: string) => void): () => void => {
  if (!targetUrl || typeof BroadcastChannel === 'undefined') {
    return () => undefined
  }

  const channel = new BroadcastChannel(getSSOAuthSyncChannelName(targetUrl))
  channel.onmessage = (event: MessageEvent): void => {
    const authToken = getSSOAuthTokenFromMessage(event.data, targetUrl)
    if (authToken) {
      handler(authToken)
    }
  }

  return () => {
    channel.close()
  }
}
